import { ShieldCheck } from 'lucide-react';
import {
  pruefungStatusLabel,
  pruefungStatusBadgeClasses,
} from '@/lib/akten-pruefung';

export function PruefungBadge({
  status,
  onClick,
}: {
  status: string | null | undefined;
  onClick?: () => void;
}) {
  const label = pruefungStatusLabel(status);
  if (!label) return null;

  const classes = pruefungStatusBadgeClasses(status);

  if (onClick) {
    return (
      <button
        type="button"
        data-testid="pruefung-badge"
        onClick={onClick}
        className={`inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-full flex-shrink-0 cursor-pointer ${classes}`}
        title={`QS-Status: ${label} — klicken zum Ändern`}
      >
        <ShieldCheck className="w-3 h-3" />
        <span>{label}</span>
      </button>
    );
  }

  return (
    <span
      data-testid="pruefung-badge"
      className={`inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-full flex-shrink-0 ${classes}`}
      title={`QS-Status: ${label}`}
    >
      <ShieldCheck className="w-3 h-3" />
      <span>{label}</span>
    </span>
  );
}
